module.exports = __webpack_public_path__ + "static/media/P20_Tip_Box.c3bdcd2b.svg";